"use strict";

define('libs/format/empty',['handlebars', 'underscore'], function (Handlebars, _) {
  var emptyFormatter = function emptyFormatter(empty, options) {
    options = _.extend({
      opacity: 0.5,
      color: [0, 0, 0]
    }, options);
    return function (value) {
      if (value == null || String(value).length < 1) {
        return new Handlebars.SafeString('<span class="invertable muted">' + Handlebars.escapeExpression(empty) + '</span>');
      }
      return value;
    };
  };
  return emptyFormatter;
});

